import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

const BARS_PATH = "M4 7h16M4 12h16M4 17h16"
const CLOSE_PATH = "M6 6l12 12M18 6L6 18"

document.querySelectorAll("[data-hamburger]").forEach((button) => {
  const header = button.closest(".site-header")
  const icon = button.querySelector("path")

  button.addEventListener("click", () => {
    const isOpen = header.classList.toggle("is-nav-open")
    button.setAttribute("aria-expanded", isOpen ? "true" : "false")
    if (icon) icon.setAttribute("d", isOpen ? CLOSE_PATH : BARS_PATH)
  })
})
